import Link from 'next/link'
import { Space, Typography } from 'antd'
import TruncatedId from './TruncatedId'
import type { LLM } from '@/types/llm'

type ModelLinkProps = {
  model: LLM
  primary?: boolean
  nameOnly?: boolean
}

const ModelLink = ({
  model,
  primary = false,
  nameOnly = true,
}: ModelLinkProps) => {
  return (
    <Space direction='vertical'>
      <Link type='link' href={`/ecs/models/${model.id}`}>
        {primary ? (
          <Typography.Link>{model.name ?? '--'}</Typography.Link>
        ) : (
          <Typography.Text>{model.name ?? '--'}</Typography.Text>
        )}
      </Link>
      {!nameOnly && <TruncatedId id={model.id} />}
    </Space>
  )
}

export default ModelLink
